import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarUserComponent } from './navbar-user/navbar-user.component';
import { NavbarNavComponent } from './navbar-nav/navbar-nav.component';
import { AuthService } from './services/auth.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NavbarUserComponent, NavbarNavComponent, ProgressSpinnerModule],
  styleUrl: './app.scss'
})
export class App {
  isReady = false;

  constructor(private authService: AuthService) {}

  async ngOnInit() {
    const isAuth = await this.authService.isAuthenticated();
    if (isAuth) {
      const shouldContinue = await this.authService.startMonitoring();
      if (!shouldContinue) return; // Logging out, don't render
    }
    this.isReady = true;
  }

  ngOnDestroy() {
    this.authService.stopMonitoring();
  }
}
